import { CurriculumType, MediaSlot, MediaStatus, MediaType } from "@/util/enum";
import { PrimaryLanguageLocale } from "commonui";
import { DateTime } from "wijmo/wijmo";

export interface MediaResponseModel {
	name: string;
	mediaId: number;
	metaData: string;
	versionGroupId?: string;
	versionGroup?: string;
	curriculumType?: CurriculumType;
	unitId?: number;
}

export interface MediaFileUploads {
	id: string;
	fileName: string;
	size: number;
	length?: number;
	uploaded: number;
	status?: StatusType;
	progress: number;
	filePath: string;
	languageCode?: string;
	pageId?: string;
}

export enum StatusType {
	Progress = "progress",
	Completed = "completed",
	Error = "error"
}

export interface MediaFile {
	id: string;
	file?: File;
	language?: string | PrimaryLanguageLocale;
	publishedMediaRevision?: ExistingMediaInfo;
	isMultilingual: boolean;
	progress?: number;
	isExisting: boolean;
	uploadedAt?: string | DateTime;
	length?: number;
	downloadUrl?: string;
	fileName: string;
	mediaStatusId?: number | MediaStatus;
	size: number;
	pageId?: string;
}

export interface ExistingMediaInfo {
	mediaId: string;
	uploadedAt?: string | DateTime;
	downloadUrl?: string;
}

export interface FileUploadModel {
	id: string;
	filePath: string;
	isPublished: boolean;
}

export interface MediaSlotResponseModel {
	mediaId: string;
	isPublished: boolean;
	languageCode?: string;
	uploadedAt?: string | DateTime;
	url: string;
	fileName: string;
	mediaStatusId?: number | MediaStatus;
	size: number;
}

export interface ContentMediaSlotUploadInfoModel {
	mediaSlots: MediaSlotResponseModel[];
	isPageTimingExist: boolean;
}

export interface SaveMediaUploadRequestModel {
	contentId: string;
	breakPages: boolean;
	keepPageTimings: boolean;
	mediaSlotId: number;
	uploadedFiles: UploadMediaFileRequestModel[];
	removeMediaIds: string[];
}

export interface UploadMediaFileRequestModel {
	languageCode?: string;
	id: string;
	fileName: string;
	uploadedFilePath: string;
	length?: string;
	size?: number;
	pageId?: string;
}

export interface HasPdfContentResponseModel {
	mediaSlot: number;
	mediaStatus: number;
}

export interface ContentMediaSlotStatusModel {
	mediaId: string;
	isPublished: boolean;
	languageCode?: string;
	mediaStatusId: number | MediaStatus;
	mediaSlotId: number | MediaSlot;
	uploadedAt?: string | DateTime;
	url: string;
	fileName: string;
	size: number;
	pageId?: string;
}

export interface ContentMediaSlotStatusInfoModel {
	mediaSlots: ContentMediaSlotStatusModel[];
}

export interface PageAndAudioMediaModel {
	pageId: string;
	url: string;
	sequence?: number;
	individualAudioMediaId: string;
	individualAudioStatus?: number;
	size? : number;
	uploadedAt?: DateTime;
	fileName: string;
}

export interface PageAudioModel {
	pageInitialUrl: string;
	pageAudioMediaList: PageAndAudioMediaModel[];
}

export interface PageAndAudioMediaResponseModel {
	id: string;
	contentId: string;
	mediaSlotId?: number | MediaSlot;
	mediaStatusId?: number | MediaStatus;
	url: string;
	totalPages: number;
	pageAudio: PageAudioModel
}